import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@design-system';

import { Loader2, UserPlus } from 'lucide-react';

import { useFillIntakeForm } from '@/features/invite-client';

export function FillIntakeFormTab() {
  const { form, onSubmit, isLoading } = useFillIntakeForm();

  return (
    <div className="space-y-6">
      <div>
        <h4 className="text-base font-semibold text-gray-950">Fill Intake Form for Client</h4>
        <p className="text-foreground text-sm">
          Enter your client's name to add them and complete the intake form on their behalf. No
          invitation will be sent.
        </p>
      </div>

      <Form {...form}>
        <form
          onSubmit={onSubmit}
          className="space-y-6"
        >
          <div className="space-y-6">
            <FormField
              control={form.control}
              name="firstName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>First name</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="John"
                      disabled={isLoading}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="lastName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Last name</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Doe"
                      disabled={isLoading}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={!form.formState.isValid || isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="size-4 animate-spin" />
                Creating...
              </>
            ) : (
              <>
                <UserPlus className="size-4" />
                Add Client & Open Form
              </>
            )}
          </Button>
        </form>
      </Form>
    </div>
  );
}
